angular.module('zc.projects')

.directive 'campaignTimingStep', ($state, $q, $translate, CampaignSegment, Project, Meta, MongoSession, SegmentMatcher, $filter) ->
  restrict: 'E'
  scope:
    project: '='
    campaign: '='
    timingForm: '='
    configurationTypes: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_timing_step.html'
  link: (scope, element, attrs) ->
    DATE_UNTIL = moment().subtract(1, 'hours').toDate()
    DATE_FROM = moment(DATE_UNTIL).subtract(2, 'week').toDate()
    SAMPLE_DATE_FROM = moment(DATE_UNTIL).subtract(1, 'day').toDate()

    scope.campaign_policy_has_errors = false
    scope.timing_overrides_segment = false
    scope.sampleSessionSize = 500
    scope.sessions = []
    scope.adminProjectsDetailUrl = $state.href('admin.projects.detail', { projectId: scope.campaign.project_id })
    scope.timingSettingsURL = "#{ZC_CONFIG.AIDEAL_URL}/site/#{scope.project.apikey}/campaigns/#{scope.campaign.id}/timing"
    scope.sampling_ranges = {}

    Meta.getSamplingRanges().then (res) ->
      scope.sampling_ranges = res

    Project.get(scope.campaign.project_id, {with_campaign_policies: true}).then (project) ->
      scope.campaign_policy_sets = project.campaign_policy_sets
      scope.campaign_policy_sets.unshift { id: null, name: $translate.instant('projectsCampaigns.directives.campaignTimingStep.unspecified') }

      policy_set_found = false
      for set in scope.campaign_policy_sets
        if set.id is scope.campaign.campaign_policy_set_id
          policy_set_found = true
          break
      unless policy_set_found
        scope.campaign.campaign_policy_set = null
        scope.campaign.campaign_policy_set_id = null

      findCampaignPolicySet scope.campaign.campaign_policy_set_id

      scope.$watchGroup [
        'campaign.segment_id'
        'campaign.campaign_policy_set_id'
      ], checkTimingSegmentOverlap, true

    confirmTotalQuery = ->
      scope.campaign_policy_has_errors = false
      promises = _.map scope.campaign.campaign_policy_set.campaign_policies, (campaign_policy) ->
        $q (resolve, reject) ->
          sessionQuery = SegmentMatcher.createSegmentQuery(campaign_policy)
          sessionQuery = _.assignIn sessionQuery, {
            apikey: scope.project.apikey,
            opened_at: { $gte: moment().subtract(1, 'hours').toDate() }
          }
          MongoSession.find(sessionQuery, { limit: 1 })
          .catch (error) ->
            reject error
      promises = promises.concat _.map scope.campaign.campaign_policy_set.campaign_policies, (campaign_policy) ->
        $q (resolve, reject) ->
          historyQuery = SegmentMatcher.createHistoryQuery(campaign_policy)
          historyQuery = _.assignIn historyQuery, {
            apikey: scope.project.apikey,
            opened_at: { $gte: moment().subtract(1, 'hours').toDate() }
          }
          # We use MongoSession to throw the query, not history, because the
          # API is not public.
          # Because we just want to know if there were errors or not, it does
          # not really matter if we get match or not.
          MongoSession.find(historyQuery, { limit: 1 })
          .catch (error) ->
            reject error
      promises = promises.concat _.map scope.campaign.campaign_policy_set.campaign_policies, (campaign_policy) ->
        $q (resolve, reject) ->
          visitorQuery = SegmentMatcher.createVisitorQuery(campaign_policy)
          visitorQuery = _.assignIn visitorQuery, {
            apikey: scope.project.apikey,
            opened_at: { $gte: moment().subtract(1, 'hours').toDate() }
          }
          # We use MongoSession to throw the query, not visitor, because the
          # API is not public.
          # Because we just want to know if there were errors or not, it does
          # not really matter if we get match or not.
          MongoSession.find(visitorQuery, { limit: 1 })
          .catch (error) ->
            reject error

      $q.all(promises).catch (errors) ->
        alertify.error $translate.instant('projectsCampaigns.directives.campaignTimingStep.errorTiming')
        scope.campaign_policy_has_errors = true

    findCampaignPolicySet = (campaign_policy_set_id) ->
      scope.campaign.campaign_policy_set = _.find scope.campaign_policy_sets,
        id: campaign_policy_set_id
      if scope.campaign.campaign_policy_set
        confirmTotalQuery()

    findSessions = (query) ->
      query = SegmentMatcher.createSegmentQuery(query)
      device = SegmentMatcher.getCombinedDeviceCondition(scope.campaign.campaign_device)
      MongoSession.find _.assignIn(query,
        apikey: scope.project.apikey
        device: device
        opened_at:
          $gte: SAMPLE_DATE_FROM
          $lt: DATE_UNTIL
      )
      ,
        limit: 1
        fields: ['_id']
      .then (found) ->
        return [] unless found
        MongoSession.find _.assignIn(query,
          apikey: scope.project.apikey
          device: device
          opened_at:
            $gte: DATE_FROM
            $lt: DATE_UNTIL
        )
        ,
          sort: '-opened_at'
          limit: scope.sampleSessionSize
          fields: [
            'conversion_count'
            'predictions_min_before_cart.global_conversion_rate'
            'predictions_max_before_cart.global_conversion_rate'
            'average_recent5_item_price'
          ]

    scope.getSegmentData = ->
      return unless scope.campaign.segment
      return unless scope.campaign.segment.conditions_json
      CampaignSegment.getMongoQuery(scope.campaign.segment)
      .then (query) ->
        findSessions(query)
      .then (sessions) ->
        scope.sessions = sessions

    setValidity = (segmentId) ->
      scope.timingForm.$setValidity('segmentId', !!segmentId, window);

    checkTimingSegmentOverlap = ->
      scope.timing_overrides_segment = false

      selected_segment = _.find scope.project.campaign_segments,
        id: scope.campaign.segment_id
      return unless selected_segment

      selected_policy_set = _.find scope.campaign_policy_sets,
        id: scope.campaign.campaign_policy_set_id
      return unless selected_policy_set

      segment_mongo_query_keys = _.keys selected_segment.mongo_query
      _.each selected_policy_set.campaign_policies, (policy) ->
        timing_mongo_query_keys = $filter('segmentRelevantHeaders')([policy])
        if _.intersection(segment_mongo_query_keys, timing_mongo_query_keys).length
          scope.timing_overrides_segment = true
          return

    scope.$watch 'campaign.campaign_policy_set_id', findCampaignPolicySet
    scope.$watch 'campaign.segment_id', setValidity
    scope.$watchGroup [
      'campaign.campaign_device'
      'campaign.segment'
      'sampleSessionSize'
    ], scope.getSegmentData, true
    scope.$watch 'campaign.configuration_type', () ->
      if scope.campaign.configuration_type not in ['ai_model', 'uplift_modeling'] and scope.campaign.score_threshold != 0.5
        scope.campaign.score_threshold = 0.5
      if scope.campaign.configuration_type isnt 'ai_model' and scope.campaign.auto_configuration
        scope.campaign.auto_configuration = false
      if scope.campaign.configuration_type isnt 'conversion_prediction' and scope.campaign.exclude_cart_button_click
        scope.campaign.exclude_cart_button_click = false
      if scope.campaign.configuration_type isnt 'conversion_prediction' and scope.campaign.exclude_no_price
        scope.campaign.exclude_no_price = false
      if scope.campaign.configuration_type isnt 'csv_upload' and  scope.campaign.campaign_policy_set_id != null
        scope.campaign.campaign_policy_set_id = null
      if scope.campaign.configuration_type isnt 'sampling' and scope.campaign.sampling_range != null
        scope.campaign.sampling_range = null



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_timing_step.directive.coffee